import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { ChatBox } from './chat-box';
import { DefaultChat } from './default-chat';
import { useFilaTransbordo } from '../../../context/FilaTransbordoContext';
import { formatarTelefone } from '../../../utils/formatFone'
import { FaUserCircle } from 'react-icons/fa';
import { IoCall, IoLogoWhatsapp } from 'react-icons/io5';
import { Ligacao } from '../../Callback/chat/components/ligacao';
import { LigacaoExpert } from '../../Callback/chat/components/ligacao/expert';
// import { IoLogoWhatsapp } from 'react-icons/io';



interface ChatProps {
  isOpen: boolean;
  // closeSidebar: Dispatch<SetStateAction<boolean>>;
  // operadora: string
}

export const Chat = ({ }: ChatProps) => {
  const [chat, setChat] = useState('WhatsApp');
  const { clearSelectedFila, devedorFilaSelected } = useFilaTransbordo()

  // useEffect(() => {
  //   clearSelectedFila()
  // }, [])

  // ${isOpen ? 'translate-x-0 ' : 'translate-x-full'}

  // function handleChoice(channel: string) {
  //   setChat(channel)
  // }

  // function renderLigacao() {
  //   if (operadora === '3C') return <Ligacao />
  //   if (operadora === 'Expert') return <LigacaoExpert />
  //   return <></>
  // }

  return (
    <div
      className={`fixed top-[104px] right-0 z-50  h-[85vh] w-[20vw] border py-2  text-gray-800 bg-white`}
    >
      {
        chat !== '' && (
          <div className="flex w-full items-center justify-between -mt-2 -mb-1 px-2 text-xs">
            <button
              className={`${chat === 'WhatsApp' ? 'border-2 border-green-600 bg-green-600 text-white' : 'bg-white text-gray-800  '
                } my-2 flex items-center gap-2 text-sm rounded-md px-2 py-2 text-center font-medium`}
              onClick={() => setChat('WhatsApp')}
            >
              <IoLogoWhatsapp color={chat === 'WhatsApp' ? '#FFF' : '#1f2937 '} size={20} />
              WhatsApp
            </button>
            {/* <button
              className={`${chat === 'Ligação' ? 'border-2 border-green-600 bg-green-600 text-white' : 'bg-white text-gray-800 '
                } my-2 flex items-center gap-2 text-sm rounded px-2 py-2 text-center font-medium`}
              onClick={() => setChat('Ligação')}
            >
              <IoCall color={chat === 'Ligação' ? '#FFF' : '#1f2937 '} />
              Ligação
            </button> */}

          </div>
        )
      }

      {
        (chat === 'WhatsApp' && devedorFilaSelected && devedorFilaSelected._id) && (
          <div className=" flex w-[100%] items-center gap-2 bg-primary  px-4 py-2">
            <div className='w-[10%]'>
              <FaUserCircle className='fill-white' size={40} />

            </div>

            <div className=" flex w-full items-center gap-2 flex-col text-xs ">
              <p className='w-[90%] text-center truncate text-ellipsis font-semibold text-white'>
                {devedorFilaSelected?.name && devedorFilaSelected?.name.toUpperCase()}

              </p>

              <p className='text-white'>
                {devedorFilaSelected?.chatData.foneNumber && formatarTelefone(devedorFilaSelected?.chatData.foneNumber)}
              </p>

            </div>
          </div>
        )
      }


      <div className="flex w-full h-full items-center justify-center ">
        {(chat === 'WhatsApp' && devedorFilaSelected?._id) && <ChatBox type="whatsapp" />}
        {chat === '' && !devedorFilaSelected && <DefaultChat />}
        {/* {chat === 'LigaÃ§Ã£o' && <>{renderLigacao()}</>} */}
      </div>
    </div>
  );
};